import { Component, Input } from '@angular/core';
import { PurchaseSalesReport } from '../../../models/purchaseSalesReport';

@Component({
  selector: 'app-report-purchase-table',
  templateUrl: './report-purchase-table.component.html',
  styleUrl: './report-purchase-table.component.scss'
})
export class ReportPurchaseTableComponent {
  
  @Input() dataSource:PurchaseSalesReport[] = []
  @Input() reportTypeGrid:any
}
